﻿import { Component, Attribute, Input, Output, Inject } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { Severity } from "../../models/serviceCase";
@Component({
    module: FIQAssist,
    selector: 'severitybar',
    template: `<radiobar read-only="$ctrl.readOnly" group="severity" value="1" onoptionchanged="$ctrl.OnSeverityChanged(value)">
                    <radiobaroption active="$ctrl._severity == 'level1'" value="'level1'" text="'1'" hint="'MTTR_HOURS' | translate"
                        notallowed="'level1' < $ctrl._maxseverity" activecolor="'red'"></radiobaroption>
                    <radiobaroption active="$ctrl._severity == 'level2'" value="'level2'" text="'2'" hint="'MTTR_DAYS' | translate"
                        notallowed="'level2' < $ctrl._maxseverity" activecolor="'orange'"></radiobaroption>
                    <radiobaroption active="$ctrl._severity == 'level3'" value="'level3'" text="'3'" hint="'MTTR_WEEKS' | translate"
                        notallowed="'level3' < $ctrl._maxseverity" activecolor="'blue'"></radiobaroption>
                    <radiobaroption active="$ctrl._severity == 'level4'" value="'level4'" text="'4'" hint="'MTTR_NEXT_RELEASE' | translate"
                        notallowed="false" activecolor="'blue'"></radiobaroption>
                </radiobar>
`
})
export class SeverityBar {
    @Input() public readOnly: boolean;
    private _severity: Severity;
    private _maxseverity: Severity;
    private _isInitialized: boolean = false;

    @Input()
    public get severity(): Severity {
        return this._severity;
    }
    public set severity(val: Severity) {
        this._severity = val;
    }

    @Input()
    public get maxseverity(): Severity {
        return this._maxseverity;
    }
    public set maxseverity(val: Severity) {
        this._maxseverity = val;
    }

    @Output() public onclicked: (args: { severity: Severity }) => void;


    constructor( @Inject('$element') private $element: angular.IRootElementService) {

    }

    $onInit() {
        this._isInitialized = true;
    }

    private OnSeverityChanged(value: Severity) {
        this.severity = value;
        this.onclicked({ severity: this.severity });
    }
}

